import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { HStack, Image, Text, VStack } from "native-base";
import moment from "moment";
import bus from "../../assets/icons/bus.svg";
import location from "../../assets/icons/location.svg";
import seat from "../../assets/icons/seat.svg";
import calendar from "../../assets/icons/calendar.svg";
import routes from "../../routes";
import colors from "../../constants/colors";

function Quotation(props) {
  const { quotation, role } = props;

  const origin = quotation.itinerary.find(
    (location) => !location.isReturn && location.type === "origin",
  );
  const destination = quotation.itinerary.find(
    (location) => !location.isReturn && location.type === "destination",
  );

  return (
    <Link
      to={(role === "user"
        ? routes.experienceCreationTransportSelection
        : routes.agencyExperienceCreationTransportSelection
      ).replace(":id", quotation.id)}>
      <VStack
        padding={6}
        backgroundColor="white"
        borderRadius={5}
        space={5}
        minWidth={300}
        maxWidth={400}
        width="full"
        shadow="1">
        <Text>
          Folio: <Text bold>{quotation.id}</Text>
        </Text>
        <HStack>
          <HStack flex={1} space={2}>
            <Image
              src={bus}
              alt="bus"
              width={25}
              height={25}
              tintColor={colors.secondary}
            />
            <Text flex={1}>{origin?.name}</Text>
          </HStack>
          <HStack flex={1} space={2}>
            <Image
              src={location}
              alt="location"
              width={25}
              height={25}
              tintColor={colors.secondary}
            />
            <Text flex={1}>{destination?.name}</Text>
          </HStack>
        </HStack>
        <HStack>
          <HStack flex={1} space={2}>
            <Image
              src={seat}
              alt="seat"
              width={25}
              height={25}
              tintColor={colors.secondary}
            />
            <Text>{quotation.numberOfPassengers}</Text>
          </HStack>
          <HStack flex={1} space={2}>
            <Image
              src={calendar}
              alt="calendar"
              width={25}
              height={25}
              tintColor={colors.secondary}
            />
            <Text>
              {moment(origin?.departureDate).format(moment.HTML5_FMT.DATE)}
            </Text>
          </HStack>
        </HStack>
      </VStack>
    </Link>
  );
}

Quotation.propTypes = {
  quotation: PropTypes.object.isRequired,
  role: PropTypes.string,
};

Quotation.defaultProps = {
  role: "agency",
};

export default React.memo(Quotation);
